module.exports = __webpack_public_path__ + "img/cjc1_style_4_font_sprite.ac70411b.webp";